// extracted by mini-css-extract-plugin
export default {"marginButton":"style_marginButton__yr7tz","message":"style_message__A5N5k","messageContainer":"style_messageContainer__nxp3v"};